import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { ApolloProvider } from 'react-apollo';
import { Provider as UrqlProvider } from 'urql';

import { MediaProvider } from './utils/media-provider';
import bootstrap from 'bootstrap';
import Root from 'routes/Root';
import ErrorBoundary from 'components/ErrorBoundary';
import { DiContainerProvider } from '@tokamakjs/react';


bootstrap((store, history, client, urqlClient, diContainer) => {
  const App = () => {
    return (
      <Provider store={store}>
        <ApolloProvider client={client}>
          <UrqlProvider value={urqlClient}>
            <MediaProvider>
              <Router history={history}>
                <DiContainerProvider value={diContainer}>
                  <ErrorBoundary>
                    <Root />
                  </ErrorBoundary>
                </DiContainerProvider>
              </Router>
            </MediaProvider>
          </UrqlProvider>
        </ApolloProvider>
      </Provider>
    );
  };

  createRoot(document.getElementById('root')).render(<App />);
});
